import { AxiosResponse } from 'axios';
import {
  SET_EVENT_TEMPLATE,
  SET_EVENT_TEMPLATES,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CLEAR_EVENT_TEMPLATE_ISLOADING,
  DELETE_EVENT_TEMPLATE,
  EDIT_EVENT_TEMPLATE,
  GET_EVENT_TEMPLATES,
  REGISTER_EVENT_TEMPLATE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EventTemplate from '@/services/event_template';
import { Module } from 'vuex';
import {
  EditEventTemplate,
  RegisterEventTemplate,
  GetEventTemplate,
} from '@/dtos/event_template.dto';

/** Mirror of the donation `template` module, for the event layouts. */
const eventTemplate: Module<any, {}> = {
  state: {
    eventTemplate: {
      data: null,
      isLoading: false,
    },
    eventTemplates: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    eventTemplate: (state: { eventTemplate: any }) => state.eventTemplate,
    eventTemplates: (state: { eventTemplates: any }) => state.eventTemplates,
  },
  mutations: {
    [SET_EVENT_TEMPLATE]: (
      state: { eventTemplate: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.eventTemplate.data = payload.data) : null,
        (state.eventTemplate.isLoading = payload.isLoading);
    },
    [SET_EVENT_TEMPLATES]: (
      state: { eventTemplates: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.eventTemplates.data = payload.data) : null,
        (state.eventTemplates.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EVENT_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_EVENT_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EventTemplate.registerEventTemplate(
        payload as RegisterEventTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EVENT_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [GET_EVENT_TEMPLATES]: async ({ commit }: any, payload: any) => {
      commit(SET_EVENT_TEMPLATES, { data: null, isLoading: true });

      const result: AxiosResponse = await EventTemplate.getEventTemplates(
        payload as GetEventTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EVENT_TEMPLATES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT_TEMPLATES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT_TEMPLATES, { isLoading: false });
        return false;
      }
    },
    [EDIT_EVENT_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_EVENT_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EventTemplate.editEventTemplate(
        payload as EditEventTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EVENT_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [DELETE_EVENT_TEMPLATE]: async ({ commit }: any, payload: string) => {
      commit(SET_EVENT_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EventTemplate.deleteEventTemplate(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_EVENT_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EVENT_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EVENT_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EVENT_TEMPLATE_ISLOADING]: ({ commit }) => {
      commit(SET_EVENT_TEMPLATE, { isLoading: false });
      commit(SET_EVENT_TEMPLATES, { isLoading: false });
    },
  },
};

export default eventTemplate;
